import React from "react";
import classNames from 'classnames';
import '../../assets/sass/global/dvider.scss';

const Divider = (props) => {
    const {direction, size, show} = props;
    const directionClass = direction === 'vertical' ? 'vertical' : 'horizontal';
    const sizeClass = `_${size ?? '1x'}`;

    if (!show) return null;
    return (
        <div className={classNames("divider", directionClass, sizeClass)}/>
    )
};

export default Divider;
